import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../_services/auth/auth.service';
import { Utilisateur } from '../../_interfaces/utilisateur';

@Component({
    selector: 'app-admin-navbar',
    imports: [CommonModule, RouterModule],
    templateUrl: './admin-navbar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './admin-navbar.component.scss'
})
export class AdminNavbarComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);

  isSidebarOpen = false;
  currentUser$: Observable<Utilisateur | null> = this.authService.currentUser$;

  ngOnInit() {}

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  initials(user: Utilisateur | null): string {
    if (!user) return '?';
    const f = (user.firstName || '').trim().charAt(0).toUpperCase();
    const l = (user.lastName || '').trim().charAt(0).toUpperCase();
    return (f + l) || '?';
  }
}
